import classNames from 'classnames';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';

import css from './block-title.module.scss';

type Size = 'lg' | 'md' | 'sm';

interface Props extends HTMLAttributes<HTMLDivElement> {
  size?: Size;
  supportive?: boolean;
  marginBottomMd?: boolean;
  paddingBottomMdExtra?: boolean;
  textCenter?: boolean;
  bgLight?: boolean;
  withoutBaseStyles?: boolean;
}

const BlockTitle: FC<PropsWithChildren<Props>> = ({
  className,
  children,
  size = 'lg',
  supportive = false,
  marginBottomMd = false,
  paddingBottomMdExtra = false,
  textCenter = false,
  bgLight = false,
  withoutBaseStyles = false,
  ...rest
}) => {
  const sizeClassMap = {
    lg: css.blockTitleLg,
    md: css.blockTitleMd,
    sm: css.blockTitleSm,
  };

  return (
    <div
      className={classNames(
        {
          'block-title': !withoutBaseStyles,
          [css.blockTitle]: !withoutBaseStyles,
          [sizeClassMap[size]]: size,
          [css.blockTitleSupportive]: supportive,
          [css.blockTitleMarginBottomMd]: marginBottomMd,
          [css.blockTitlePaddingBottomMdExtra]: paddingBottomMdExtra,
          [css.blockTitleTextCenter]: textCenter,
          [css.blockTitleBgLight]: bgLight,
        },
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export default BlockTitle;
